import {
    convertNumberMonthsToString
} from "@/app/[locale]/common/utils/functions/convertNumberMonthsToString/convertNumberMonthsToString";

export const convertDateFormat = (date: string) => {
    const arrDate = date.slice(0, 10).split('-');
    const month = convertNumberMonthsToString(arrDate[1]);
    const day = arrDate[2];
    const year = arrDate[0];

    return `${day} ${month} ${year}`;
};